module.exports = __webpack_public_path__ + "img/image18.b2ddef9f.webp";